export const notifications = api => ({
  dismiss(id, success, fail) {
    api.authenticatedRequest('PUT', `/notifications/${id}/dismissed`, null, success, fail);
  },
  dismissAll(success, fail) {
    api.authenticatedRequest('PUT', '/notifications/dismissAll', null, success, fail);
  },
  get(user, page, limit, success, fail) {
    api.authenticatedRequest('GET', `/notifications/${user}?page=${page}&limit=${limit}`, null, success, fail);
  },
  markAsSeen(user, notificationIds, markAllAsSeen, success, fail) {
    api.authenticatedRequest('PUT', `/notifications/${user}/seen`, { notifications: notificationIds, markAllAsSeen }, success, fail);
  },
  markAsInteracted(user, notification, success, fail) {
    api.authenticatedRequest('PUT', `/notifications/${user}/interacted`, { notification }, success, fail);
  },
});
